import { openBlock as t, createElementBlock as l, createElementVNode as n } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function r(c, e) {
  return t(), l("svg", o, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M10 3c3.871 0 7 3.129 7 7s-3.129 7-7 7-7-3.129-7-7 3.129-7 7-7m2.513 3.5L10 9.013 7.487 6.5l-.987.987L9.013 10 6.5 12.513l.987.987L10 10.987l2.513 2.513.987-.987L10.987 10 13.5 7.487z"
    }, null, -1)
  ])]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
